import React from "react";
import styles from "./Utilities/styles.module.css"

export const CampaignNamesDropdown = ({ onSelectChangeHandler, dropdownOptions }) => {
    return (
        <div className={`${styles["campaignNamesDropdownContainer"]} scrollable-campaign-list`}>
            {dropdownOptions && dropdownOptions.map(option =>
                <div
                    key={option.id}
                    className="filter-options-div"
                    onClick={() => onSelectChangeHandler(option)}>
                    {option.name}
                </div>
            )}
        </div>
    )
}